import React, { createContext, FC, PropsWithChildren } from 'react';
import { useDnsAcceptance } from '../hooks/use-dns-acceptance';
import { DnsAcceptanceFormData } from '../types/dns-acceptance';
import { FormikHelpers } from 'formik';

export const DnsAcceptanceContext = createContext<ReturnType<typeof useDnsAcceptance>>({
  initialValues: {
    trackCode: '',
    stateId: '',
    autoPrint: false,
    branchCheck: false
  },
  currentParcelFields: { weight: 0, count: 0, data: [] },
  onSubmit: (values: DnsAcceptanceFormData, helpers: FormikHelpers<DnsAcceptanceFormData>) => Promise.resolve(true),
  customErrors: 'initial',
  setCustomErrors: () => { }
});

export const DnsAcceptanceProvider: FC<PropsWithChildren> = ({ children }) => {
  const value = useDnsAcceptance();
  return <DnsAcceptanceContext.Provider value={value}>{children}</DnsAcceptanceContext.Provider>;
};
